<script>
import Title from "@/components/_Shared/Title";
import Description from "./Description";

export default {
  components: {
    Title,
    Description
  },

  mounted() {
    if (this.$refs.description) {
      this.$refs.description.scrollIntoView({ behavior: "smooth" });
    }
  }
};
</script>

<template>
  <div class="additional-information" ref="description">
    <Title title="Detalhe a sua limpeza" />

    <Description />
  </div>
</template>

<style scoped>
.additional-information {
  margin-top: 20px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/AdditionalInformation/Index.vue